<script lang="ts" setup>
import type { MenuButtonLayout } from '@brighterly/lib-lumee-ui'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { useKidStore } from '@stores/kid'

import { useKidRoutes } from '@composables/routes/kid-route.hook'
import { useDisciplineInKid } from '@hooks/discipline/discipline-in-kid.hook'
import { useDisciplineLink } from '@composables/widgets/menu/discipline-link.hook'

import HeaderNavItem from '@Molecules/HeaderNavItem.vue'

defineOptions({
  name: 'LinkDisciplineMath',
})

defineProps<{
  layout: MenuButtonLayout
}>()

const text = 'Math'

const kidStore = useKidStore()

const {
  homeMath,
  isRouteDisciplineMath,
} = useKidRoutes()

const { isDisciplineMath } = useDisciplineInKid()

const { discount, handleClick } = useDisciplineLink({
  discipline: Discipline.Math,
  isDiscipline: isDisciplineMath,
  isRouteDiscipline: isRouteDisciplineMath,
  homeRoute: homeMath,
  trackName: 'link_discipline_math',
  text,
})

</script>

<template>
  <HeaderNavItem
    :layout="layout"
    icon="ruler-triangle"
    :label="text"
    :href="homeMath ?? undefined"
    :selected="isRouteDisciplineMath"
    :disabled="!kidStore.hasActiveKid"
    :discount="discount"
    @click="handleClick"
  />
</template>
